module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pulmonology1@3x.33222d1f.png";